import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  pageNavCircleBtn: {
    width: 14,
    height: 14,
    padding: 0,
    background: '#787878',
    border: 'none',
    borderRadius: '50%',
    margin: '0 3px',
    [theme.breakpoints.down(370)]: {
      margin: '0 2px',
      width: 12,
      height: 12,
    }
  },
  active: {
    background: '#FF9A03',
  }
}));
